import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: 'Чи проводите ви первинний аналіз справи безкоштовно?',
  answer: 'Так, під час першої короткої розмови ми оцінюємо загальну ситуацію та перспективу вашої справи. Якщо ми бачимо, що закон повністю на вашому боці або, навпаки, справа не має юридичного сенсу — ми скажемо про це прямо, заощадивши ваш час та гроші.'
}, {
  question: 'Як зафіксовані ціни на послуги та чи не зростуть вони в процесі роботи?',
  answer: 'Усі фінансові умови чітко прописуються в офіційному договорі про надання правової допомоги перед початком роботи. Сума гонорару є фіксованою і не змінюється під час процесу, незалежно від кількості судових засідань чи підготовлених документів.'
}, {
  question: "Чи обов'язково мені особисто ходити в суди, ТЦК або інші держоргани?",
  answer: 'У 90% випадків — ні. Після підписання договору та оформлення представництва я повністю беру на себе комунікацію з державними органами, судами, банками чи ТЦК. Ви можете продовжувати займатися своїми справами, поки я захищаю ваші інтереси.'
}, {
  question: 'Чи працюєте ви дистанційно, якщо я перебуваю в іншому місті чи за кордоном?',
  answer: 'Так, ми працюємо по всій Україні та з клієнтами за кордоном. Договір можна підписати за допомогою ЕЦП (Електронного цифрового підпису) або через обмін документами, а всі консультації та звіти по справі проходять у зручному для вас месенджері чи через Zoom/Teams.'
}, {
  question: 'Які гарантії ви даєте, що справа буде виграна?',
  answer: 'Жоден чесний адвокат за законом не має права гарантувати 100% результат у суді. Проте я гарантую максимальну кваліфікацію, ретельний аналіз судової практики та використання всіх законних механізмів для досягнення потрібного результату. Якщо справа завідомо програшна — я попереджу про це ще до підписання договору.'
}, {
  question: 'Чи гарантується повна конфіденційність мого звернення?',
  answer: 'Безумовно. Будь-яка інформація, яку ви передаєте мені, захищена Законом України «Про адвокатуру та адвокатську діяльність» і є адвокатською таємницею. Вона не може бути розголошена третім особам, правоохоронним або державним органам за жодних обставин.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-24 bg-background" data-id="element-72">
      <div className="max-w-3xl mx-auto px-6" data-id="element-73">
        <div className="text-center mb-16" data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-75">
            Поширені запитання
          </h2>
        </div>

        <div className="space-y-4" data-id="element-76">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-border rounded-2xl overflow-hidden bg-surface" data-id="element-77">
              <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-78">
                <span className="font-medium text-primary pr-4" data-id="element-79">
                  {faq.question}
                </span>
                <ChevronDown className={`text-secondary transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-80" />
              </button>
              <AnimatePresence data-id="element-81">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-82">
                    <div className="px-6 pb-5 text-secondary leading-relaxed border-t border-border/50 pt-4" data-id="element-83">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}